module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/workshops-cdb1793e80b050c6f69fbb253f695db9.png";